<template>
  <div class="filter-el">
    <icon-base gray class="filter-el__icon-right">
      <icon-magnifier id="curr-table-filter-icon"/>
    </icon-base>
    <div class="filter-el__hint">
      <span v-if="showPlaceholder" class="filter-el__hint-el filter-el__hint-el_mobile-hidden">{{placeholder}}</span>
      <span v-else class="filter-el__hint-el filter-el__hint-el_invisible">{{value}}</span>
      <template v-if="value && !inProgress">
        <span class="filter-el__hint-el filter-el__hint-el_results" v-if="foundTickersCount"> – {{foundTickersCount}} results</span>
        <span class="filter-el__hint-el filter-el__hint-el_results" v-else> – nothing found</span>
      </template>
    </div>
    <input
      class="filter-el__input"
      v-bind="$attrs"
      @focus.native="active = true"
      @blur.native="active = false"
      @input="$emit('input', $event.target.value)"
      :value="value"
      type="text"
      maxlength="80"
    >
  </div>
</template>

<script>
import IconMagnifier from 'src/components/icons/IconMagnifier';

export default {
  components: {
    IconMagnifier,
  },
  inheritAttrs: false,
  data: () => ({
    active: false,
  }),
  props: {
    value: String,
    placeholder: String,
    foundTickersCount: Number,
    inProgress: Boolean,
  },
  computed: {
    showPlaceholder() {
      return !this.value && !this.active;
    },
  },
};
</script>


<style lang="scss" scoped>
$left: 65px;
$top: 24px;
.filter-el {
  position: relative;
  &__icon-right {
    position: absolute;
    top: $top + 3px;
    left: 31px;
  }
  &__input {
    border: none;
    width: 100%;
    outline: none;
    padding: $top $left;
    @include font(13px, $grey-color2, 500);
    line-height: 21px;
  }
  &__hint {
    position: absolute;
    top: $top;
    left: $left;
    pointer-events: none;
  }
  &__hint-el {
    user-select: none;
    pointer-events: none;
    @include font(13px, $white-color1, 500);
    line-height: 21px;
    &_invisible {
      opacity: 0;
    }
    &_results {
      margin-left: 3px;
    }
  }
  position: relative;
}
@media only screen and (max-width: 432px) {
  .filter-el__hint-el_mobile-hidden {
    overflow: hidden;
    display: block;
    white-space: nowrap;
    width: 45px;
  }
  .filter-el__hint-el_results {
    font-size: 12px;
  }
  .filter-el__hint-el_results {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CurrenciesTableFilter.vue